export const getEnsemblTranscripts = (state) =>
  state?.variantResult?.ensembl_transcripts;
export const getRefGenomeName = (state) => state?.genome?.name;
export const getTranscripts = (state) =>
  __IS_COMPONENTS_PORTAL__
    ? state?.variantResult?.genes?.[state.selectedGeneIndexClinical]
        ?.transcripts
    : state?.variantResult?.transcripts;
export const getProteinViewerData = (state) => state.proteinViewerData;
